var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { Styled } from './style';
var LoaderBar = /** @class */ (function (_super) {
    __extends(LoaderBar, _super);
    function LoaderBar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LoaderBar.prototype.render = function () {
        return (React.createElement(Styled, { "data-testid": "loaderbar" },
            React.createElement("div", { className: "indeterminate" })));
    };
    return LoaderBar;
}(React.Component));
export default LoaderBar;
//# sourceMappingURL=index.js.map